import FeeTableValue from './FeeTableValue';
import md5 from 'md5';

export default class FeeTable {
    static clone(feeTableToClone) {
        const feeTable = new FeeTable();
        feeTable.id = null;
        feeTable.start = feeTableToClone.start;
        feeTable.usingChildrenInCare = feeTableToClone.usingChildrenInCare;
        feeTable.values = feeTableToClone.values.map((feeTableValue) => FeeTableValue.clone(feeTableValue));
        feeTable.hash = md5(JSON.stringify(feeTable));

        return feeTable;
    }

    static init() {
        const feeTable = new FeeTable();
        feeTable.id = null;
        feeTable.start = {
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
        };
        feeTable.usingChildrenInCare = false;
        feeTable.values = [FeeTableValue.init('EUR')];

        return feeTable;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const feeTable = new FeeTable();
        feeTable.id = data.id;
        feeTable.start = {
            month: new Date(data.start).getMonth() + 1,
            year: new Date(data.start).getFullYear(),
        };
        feeTable.usingChildrenInCare = data.usingChildrenInCare;
        feeTable.values = data.values.data.map((value) => FeeTableValue.fromData(value));
        feeTable.hash = md5(JSON.stringify(feeTable));

        return feeTable;
    }

    toData() {
        let month = `0${this.start.month}`;
        month = month.substr(month.length - 2);
        const start = `${this.start.year}-${month}-01`;
        return {
            id: this.id,
            start,
            usingChildrenInCare: this.usingChildrenInCare,
            values: this.values.map((value) => FeeTableValue.toData(value)),
        };
    }

    hasChanged() {
        const initialHash = this.hash;
        delete this.hash;
        const currentHash = md5(JSON.stringify(this));
        const hasChanged = initialHash !== currentHash;
        this.hash = initialHash;

        return hasChanged;
    }
}
